import styles from "./case.module.scss";
import { CaseType } from "../../../types/types";
import { Link } from "react-router-dom";

const Case = ({ preview, name, types, href }: CaseType) => {
  return (
    <Link className={styles.case} to={href}>
      <img src={preview} alt={name} className={styles.case__preview} />

      <p className={styles.case__name}>{name}</p>
      <div className={styles.case__types}>
        {types.map((item) => (
          <div className={styles.type} key={item}>
            {item}
          </div>
        ))}
      </div>
    </Link>
  );
};
export default Case;
